export default __webpack_public_path__ + "static/media/carousel3.09b58033.png";